import { currentAccountFilterTemplatesSelector } from "./currentAccountFilterTemplatesSelector";
import { RootState } from "../../../store";
import { FilterSet2 } from "../../../../services/cloudchipr.api";

export const filterTemplateByIdSelector = (
  state: RootState,
  id: string,
): FilterSet2 | undefined => {
  const filterSets = currentAccountFilterTemplatesSelector(state);

  return filterSets?.find(({ filter_set }) => filter_set.id === id)?.filter_set;
};
